/**
 * Use to parse the string properties with "True" or "False" values to corresponding boolean value
 * @param value - string values
 * @example -
 * ```
 * parseBoolean(jsonData)
 * ```
 */
export const parseBooleanString = (value: string): boolean => {
  return value?.toLowerCase() === 'true';
};

/**
 * Parse input value as integer
 * @param value - input value that needs to be parsed
 *  @example -
 * ```
 * parseInteger('10')
 * ```
 */
export const parseInteger = (value: any): number => {
  if (value !== null && value !== undefined && isNaN(value) === false) {
    value = isNaN(+value) ? 0 : +value;
    return parseInt(value, 10);
  }
  return 0;
};
